export default {
  card: {
    title: 'Pagar com cartão',
    inputs: {
      number: {
        title: 'Número do cartão',
        placeholder: 'Digite o número do cartão',
      },
      cvc: {
        title: 'CVC',
        placeholder: 'CVC',
      },
      expiry: {
        title: 'MM/AA',
        placeholder: 'MM/AA',
      },
    },
  },
  'driver-tips': {
    title: 'Obrigado por<br><span>apoiar os motoristas!</span>',
    description: '100% da sua gorjeta vai diretamente para',
    remember: 'Lembre-se: deixar gorjeta é totalmente opcional!',
    'confirmation-modal': {
      title: 'Confirme, por favor:',
      description: 'Tem certeza de que deseja enviar uma gorjeta de',
      error: 'O valor da gorjeta deve estar entre $2 e $40.',
      actions: {
        confirm: 'Confirmar',
        cancel: 'Cancelar',
      },
    },
  },
  'tips-amount': {
    other: 'Outro',
  },
  'tips-component': {
    thanks: 'Obrigado! Sua gorjeta foi recebida e com certeza vai alegrar o dia do motorista.',
    more: 'Enviar mais gorjetas',
  },
  'tips-old': {
    title: 'Obrigado por<br><span>apoiar os motoristas!</span>',
    description: '100% da sua gorjeta vai diretamente para',
    btn: 'Pagar com cartão',
  },
}
